const state = {
  listaTramitacoes: [],
  listaFluxos: [],
  listaDestinosFluxo: [],
  listaValidacaoFluxo: [],
  fluxoSelecionado: null,
  destinoSelecionado: null,
  despachoSelecionado: null,
  despachoSalvo: null,
  nivelAcessoSelecionado: 'P',
  listaHipotesesLegais: [],
  hipoteseLegalSelecionada: null,
  tipoDespachoSelecionado: 'I',
  despachoPreparatorio: null
}

export default state



// WEBPACK FOOTER //
// ./src/vuex/tramitacoes/state.js